import SearchField from "../SearchField";
import PrimaryButton from "../../CommonButtons/PrimaryButton";
/**
 * @callback InputHandler
 * @param {string} data
 * @returns {undefined}
 */
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @param {Object} props
 * @param {String} props.searchText - input value
 * @param {Object} [props.searchRef] - ref for input field
 * @param {String} props.placeholder - placeholder for input field
 * @param {Boolean} props.isSearchDisabled - disabled attribute for input field
 * @param {InputHandler} props.onInput - Function to process input.
 * @param {String} props.btnText - Default string to show
 * @param {OnClickEventHandler} props.onClick - What to do when click on button
 * @param {Object} [props.btnRef] - Button ref (optional) eg:- state of button ref
 * @param {String} props.txtColor - Color of text when button is enabled (var only)
 * @param {boolean} props.isBtnDisable
 * @param {String} props.btnColor - Color of bg when button is enabled (var only)
 * @param {String?} props.disabledBtnColor - Color of text when button is disabled (defaults to enabledTextColor) (var only)
 * @param {String} props.disabledTxtColor - Color of bg when button is disabled (var only)
 * @param {boolean} props.inActiveVariantNeeded - If you want to use inActive variant of button eg:- true or false


 * @returns {JSX.Element}
 */
const SearchBar = ({
  onInput,
  searchText,
  searchRef,
  placeholder,
  isSearchDisabled,
  onClick,
  isBtnDisable,
  txtColor,
  btnColor,
  btnText,
  btnRef,
  disabledTxtColor,
  disabledBtnColor,
  inActiveVariantNeeded,
}) => {
  return (
    <div
      style={{
        maxWidth: "var(--max-content-width)",
      }}
      className="w-full flex gap-x-gap-sm justify-between items-center"
    >
      <SearchField
        onInput={onInput}
        searchText={searchText}
        searchRef={searchRef}
        placeholder={placeholder}
        isDisabled={isSearchDisabled}
      />

      <PrimaryButton
        disabledTextColor={disabledTxtColor}
        disabledBgColor={disabledBtnColor}
        enabledBgColor={btnColor || "var(--text-primary)"}
        btnText={btnText}
        enabledTextColor={txtColor || "var(--text-primary)"}
        handleFunction={onClick}
        hoverOption="black"
        isDisabled={isBtnDisable}
        buttonRef={btnRef}
        inActiveVariantNeeded={inActiveVariantNeeded}
      />
    </div>
  );
};

export default SearchBar;
